import type { SchemaProps } from "./Schema.d";

const Schema = ({ schema }: SchemaProps) =>
  // eslint-disable-next-line react/no-danger
  schema ? (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />
  ) : null;

export default Schema;
